// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".titulo-blog{font-size:2.6em}@media(max-width:600px){.titulo-blog{font-size:2em}}.artigo{font-size:1.3em}.texto{font-size:calc(13px + .3vw)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
